
import { Component, OnInit, AfterViewInit } from '@angular/core';

declare global {
  interface Window {
    ECT?: any;
  }
}

@Component({
  selector: 'app-icd11-ect',
  templateUrl: './icd11-ect-component.component.html',
  styleUrls: ['./icd11-ect-component.component.css']
})
export class Icd11EctComponent implements OnInit, AfterViewInit {
selected:any;
  constructor() {}

  ngOnInit(): void {
    console.log("ICD11 ECT ngOnInit");
  }

  /**
   * Espera a que la librería externa ECT quede disponible en window.
   */
  private waitForEctLoad(maxAttempts = 10, delayMs = 500): Promise<boolean> {
    let attempt = 0;
    return new Promise<boolean>((resolve) => {
      const tryNow = () => {
        attempt++;
        if ((window as any).ECT && ((window as any).ECT.Handler || (window as any).ECT.default)) {
          resolve(true);
          return;
        }
        if (attempt >= maxAttempts) {
          resolve(false);
          return;
        }
        setTimeout(tryNow, delayMs);
      };
      tryNow();
    });
  }

  // ngAfterViewInit(): void {


  //     console.log('ICD11 ECT ngAfterViewInit');

  //   const runInit = async () => {
  //     const ok = await this.waitForEctLoad(10, 500);
  //     if (!ok) {
  //       console.error('❌ No se cargó la librería ICD11 ECT');
  //       return;
  //     }

  //     const ectAny: any = (window as any).ECT || (window as any).ECT?.default;
  //     if (!ectAny) {
  //       console.error('❌ ECT presente en window pero sin estructura Handler.');
  //       return;
  //     }

  //     const settings = {
  //       apiServerUrl: '/api',           // proxy hacia tu backend
  //       apiVersion: 'v2',
  //       apiKey: 'e4b7c1c2-3d8a-44e7-babf-1a8f1d92af34',
  //       autoBind: true                     // 👈 dejamos que el widget se monte solo
  //     };

  //     const callbacks = {
  //       selectedEntityFunction: (entity: any) => {
  //         this.selected=entity;
  //         console.log('✅ Entidad ICD seleccionada:', entity);
  //                   console.log('✅ selected:', entity);

  //       }
  //     };

  //     try {
  //       console.log('Configuring ECT with settings:', settings);
  //       const HandlerCtor = ectAny.Handler || ectAny;
  //       if (HandlerCtor && typeof HandlerCtor.configure === 'function') {
  //         HandlerCtor.configure(settings, callbacks);
  //         console.log('✅ ICD11 ECT configurado con autoBind=true');
  //       } else {
  //         console.error('❌ Handler no soporta configure()', HandlerCtor);
  //       }
  //     } catch (err) {
  //       console.error('Error inicializando Handler de ECT:', err);
  //     }
  //   };

  //   runInit();
  //     // Código que se ejecuta después de que la vista está completamente renderizada
  //     console.log('Ejecutando código después de renderizado');



  // }

    ngAfterViewInit(): void {
    console.log('ICD11 ECT ngAfterViewInit');

    const runInit = async () => {
      const ok = await this.waitForEctLoad(10, 500);
      if (!ok) {
        console.error('❌ No se cargó la librería ICD11 ECT');
        return;
      }

      const ectAny: any = (window as any).ECT || (window as any).ECT?.default;
      if (!ectAny) {
        console.error('❌ ECT presente en window pero sin estructura Handler.');
        return;
      }

      const settings = {
        apiServerUrl: '/api',           // proxy hacia tu backend
        apiVersion: 'v2',
        apiKey: 'e4b7c1c2-3d8a-44e7-babf-1a8f1d92af34',
        autoBind: true                     // 👈 dejamos que el widget se monte solo
      };

      const callbacks = {
        selectedEntityFunction: (entity: any) => {
          this.selected=entity;
          console.log('✅ Entidad ICD seleccionada:', entity);
                    console.log('✅ selected:', entity);

        }
      };

      try {
        console.log('Configuring ECT with settings:', settings);
        const HandlerCtor = ectAny.Handler || ectAny;
        if (HandlerCtor && typeof HandlerCtor.configure === 'function') {
          HandlerCtor.configure(settings, callbacks);
          console.log('✅ ICD11 ECT configurado con autoBind=true');
        } else {
          console.error('❌ Handler no soporta configure()', HandlerCtor);
        }
      } catch (err) {
        console.error('Error inicializando Handler de ECT:', err);
      }
    };

    runInit();
  }
}

